import { useEffect, useState } from 'react';
import { useT } from '../i18n';
import {
  disableAutostart,
  enableAutostart,
  isAutostartEnabled,
  isDesktop,
} from '../lib/desktop-bridge';

// ANX-059 — секция настроек desktop-приложения. Render'ится только
// внутри Tauri webview; в браузере исчезает целиком.

export function DesktopSettings() {
  const t = useT();
  const [autostart, setAutostart] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isDesktop()) return;
    void isAutostartEnabled().then(setAutostart);
  }, []);

  if (!isDesktop()) return null;

  async function toggle() {
    if (busy) return;
    setBusy(true);
    try {
      if (autostart) {
        await disableAutostart();
        setAutostart(false);
      } else {
        await enableAutostart();
        setAutostart(true);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mt-4 rounded-md border border-slate-200 bg-white p-4 shadow-card">
      <h3 className="mb-3 text-xs text-slate-500">{t('desktop.title')}</h3>
      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={autostart === true}
          disabled={autostart === null || busy}
          onChange={() => void toggle()}
          className="accent-accent-600"
        />
        <span>{t('desktop.autostart')}</span>
      </label>
      <p className="mt-2 text-xs text-slate-500">{t('desktop.autostartHint')}</p>
    </div>
  );
}
